import { useEffect, useMemo, useState } from 'react';
import { Tab, TabGroup } from '@carbonify/ui';
import clsx from 'clsx';
import AccordionEntry, { AccordionEntryRecord } from 'components/Blocks/AccordionEntry';

import styles from './GenericModule.module.css';

interface FaqModuleProps {
  content: AccordionEntryRecord[];
}

export default function FaqModuleContent({ content }: FaqModuleProps) {
  const [selectedCategory, setSelectedCategory] = useState(content[0]?.category);
  const [selectedItem, setSelectedItem] = useState<string>(content[0]?.id);
  const entries = useMemo(
    () => (selectedCategory ? content.filter(({ category }) => category === selectedCategory) : content),
    [selectedCategory, content],
  );

  const categories = useMemo(() => Array.from(new Set(content.map(({ category }) => category))), [content]);

  useEffect(() => {
    const newItem = content.find(({ category }) => category === selectedCategory)?.id;

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSelectedItem(newItem || content[0].id);
  }, [content, selectedCategory]);

  return (
    <div className={styles.accordion_wrapper}>
      {categories.length > 1 ? (
        <TabGroup
          className={styles.accordion_categories}
          showAsButtonsOnMobile
        >
          {categories.map((category) => (
            <Tab
              key={category}
              active={category === selectedCategory}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </Tab>
          ))}
        </TabGroup>
      ) : null}
      <div className={clsx(styles.accordion_elements)}>
        {entries.map((item) => (
          <AccordionEntry
            {...item}
            key={item.id}
            open={item.id === selectedItem}
          />
        ))}
      </div>
    </div>
  );
}
